import { ColDef } from 'ag-grid-community';
import { FieldHeader } from '@models/companies';
import type { ViewportService } from '@services';
import { resolveFieldHeader } from './field-headers';

export interface FieldColumnConfig<T> {
  colId: string;
  field: NonNullable<ColDef<T>['field']>;
  flex?: number;
  minWidth?: number;
  width?: number;
  pinned?: ColDef<T>['pinned'];
}

export function flexColumnMinWidth(viewportService: ViewportService): number {
  return viewportService.isMobileOrBelow() ? 60 : viewportService.isTabletOrBelow() ? 80 : 100;
}

export function buildFieldColumns<T>(configs: FieldColumnConfig<T>[], fieldHeaders: FieldHeader[]): ColDef<T>[] {
  return configs
    .map((config): ColDef<T> | undefined => {
      const headerName = resolveFieldHeader(fieldHeaders, config.field);
      return headerName === undefined ? undefined : { ...config, headerName, sortable: true, filter: true };
    })
    .filter((colDef): colDef is ColDef<T> => colDef !== undefined);
}
